import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Company } from '@/_types/models/company';
import type { UserWithAssignments } from '@/_types/models/user';

export const getAssignedCompanies = async ({
  token,
}: APIRequest): APIResponsePromise<Array<Company>> =>
  await _callBackend(
    '/companies/get_user_assigned_companies',
    'GET',
    null,
    token,
  );

export const getCompany = async ({
  companyId,
  token,
}: APIRequest<{
  companyId: number;
}>): APIResponsePromise<Company & { all_owners: Array<UserWithAssignments> }> =>
  await _callBackend(`/companies/${companyId}`, 'GET', null, token);

export const setDefaultCompany = async ({
  companyId,
  token,
}: APIRequest<{
  companyId: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/set_default_company',
    'POST',
    { company_id: companyId },
    token,
  );

export const updateCompany = async ({
  companyId,
  questionnaireId,
  business_email,
  email,
  phoneNumber,
  other_email,
  street,
  zip,
  city,
  state,
  country,
  token,
  userId,
  preferred_contact_method,
}: APIRequest<{
  companyId: number;
  questionnaireId?: number;
  business_email?: string;
  email: string;
  other_email?: string;
  phoneNumber: string;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  userId: number;
  preferred_contact_method?: string | null;
}>): APIResponsePromise<void> => {
  // Update company
  await _callBackend(
    `/companies/${companyId}`,
    'PUT',
    {
      business_email,
      email,
      other_email,
      user_id: userId,
      phone_number: phoneNumber,
      street,
      zip,
      city,
      state,
      country,
    },
    token,
  );

  // Mark profile updated
  if (questionnaireId) {
    await _callBackend(
      `/questionnaires/${questionnaireId}/mark_profile_updated`,
      'POST',
      {
        company_id: companyId,
      },
      token,
    );
  }

  if (preferred_contact_method) {
    await _callBackend(
      `/users/${userId}`,
      'PATCH',
      { preferred_contact_method },
      token,
    );
  }

  await Promise.resolve();
};
